import { NgModule } from '@angular/core';
import { MainStaffComponent} from "./components/main-staff.component";
import { CommonModule } from '@angular/common';
import { ExportsRoutes } from './staff.routes';
import { JsonpModule, HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DatepickerModule } from 'ngx-bootstrap';
import { UsersStaffComponent} from "./components/dummy/users-staff.component";
import { ModifyStaffComponent} from "./components/dummy/modify-staff.component";
import { BillsGenerateComponent} from "./components/dummy/bills-generate.component";
import { StaffService } from "../../injections/staff.service";


@NgModule({
    imports: [CommonModule,
    ExportsRoutes,
    JsonpModule,
    FormsModule,
    ReactiveFormsModule,
    HttpModule,
    DatepickerModule.forRoot(),
    ],
    exports: [],
    declarations: [MainStaffComponent, UsersStaffComponent, ModifyStaffComponent, BillsGenerateComponent],
    providers: [StaffService],
})
export class StaffModule { }



// WEBPACK FOOTER //
// ./src/app/modules/staff/staff.module.ts